import React, { useState, useCallback, useEffect } from "react";
import Headerdash from "./head";
import Sidebar from "./sidebar";
import BillingPricing from "../StatusPages/ChangePlanPricing";

export default function Billing() {
  const [allSubscriptionData, setAllSubscriptionData] = useState(null);

  const handleAllSubscriptionData = useCallback((data) => {
    setAllSubscriptionData(data);
  }, []);

  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  // Fetch subscription plans from the server
  useEffect(() => {
    const fetchPricingData = async () => {
      try {
        const response = await fetch("/api/category/main"); // Adjust the API endpoint accordingly
        if (!response.ok) {
          throw new Error("Failed to fetch subscription plans");
        }
        const data = await response.json();

        // Transform the fetched data to match the expected structure
        const mappedPlans = data.map((plan) => {
          // Parse cancelledMRP and price to numbers
          const cancelledMRP = parseFloat(
            plan.dynamicPricing?.basePrice || "0"
          );
          const price = parseFloat(plan.price || "0");

          // Calculate savings percentage
          const savingsPercent = cancelledMRP
            ? Math.round(((cancelledMRP - price) / cancelledMRP) * 100)
            : 0; // Default to 0 if cancelledMRP is 0
          const freeMonths = plan.dynamicPricing?.freeMonths || "No freeMonths";

          return {
            plan: plan.name, // Assuming 'name' is the title
            price, // Assuming 'price' field exists
            planID: plan.planID, // Assuming 'planID' exists
            duration: plan.months, // Assuming 'months' field exists
            features: plan.description.split("\n"), // Assuming 'description' contains features
            savings: savingsPercent > 0 ? `${savingsPercent}` : "No Savings",
            additionalDetails:
              plan.additionalDetails || "No additional details",
            promotion: plan.promotion || "No promotion",
            freeMonths,
            cancelledMRP:
              cancelledMRP > 0 ? `$${cancelledMRP.toFixed(2)}` : "$0",
          };
        });

        setPlans(mappedPlans);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch subscription plans");
        setLoading(false);
      }
    };

    fetchPricingData();
  }, []);
  console.log("allSubscriptionData", allSubscriptionData);
  return (
    // billing Section
    <section>
      <Headerdash />
      <Sidebar />
      <div className="pt-28">
        <h3 className="max-w-5xl md:ml-80 font-bold text-2xl text-gray-700 p-3 mx-3 mb-10 border-b-2">
          Plans and Billing
        </h3>
        <BillingPricing
          onAllSubscriptionData={handleAllSubscriptionData}
          plans={plans}
        />
        <h3 className="md:ml-80 font-semibold text-sm text-gray-600 p-3 mx-3 mb-3">
          Purchase History
        </h3>
        <div className="mx-5 max-w-5xl md:ml-80">
          <table className="min-w-full divide-y-2 divide-gray-200 text-sm bg-slate-50">
            <thead className="ltr:text-left rtl:text-right">
              <tr className="bg-gray-100">
                <th className="whitespace-nowrap px-4 py-3 font-medium text-gray-900">
                  Billing Date
                </th>
                <th className="whitespace-nowrap px-4 py-3 font-medium text-gray-900">
                  Next Billing Date
                </th>
                <th className="whitespace-nowrap px-4 py-3 font-medium text-gray-900">
                  Plan
                </th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>

            {allSubscriptionData ? (
              <tbody className="divide-y divide-gray-200">
                {allSubscriptionData.map((entry, index) => (
                  <tr key={index}>
                    <td className="whitespace-nowrap px-4 py-3 font-medium text-gray-900 text-center">
                      {entry.subscriptionStartDate
                        ? new Date(
                            entry.subscriptionStartDate
                          ).toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                        : "—"}{" "}
                    </td>
                    <td className="whitespace-nowrap px-4 py-3 text-gray-700 text-center">
                      {entry.subscriptionEndDate
                        ? new Date(
                            entry.subscriptionEndDate
                          ).toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                        : "—"}{" "}
                    </td>
                    <td className="whitespace-nowrap px-4 py-3 text-gray-700 text-center">
                      {entry.beforePlan}
                    </td>
                    <td className="whitespace-nowrap px-4 py-3">
                      <a className="inline-block rounded bg-gray-800 px-4 py-2 text-xs font-medium text-white hover:bg-black">
                        {entry.subscriptionStatus}
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td colSpan="4" className="text-center py-4">
                    Loading...
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </div>
    </section>
  );
}
